import React from "react";

const QuotationComponent = ({ openQuotation }) => {
  return (
    <div className="bg-gray-300 mt-1 mb-5 py-2 p-8 rounded-xl">
      <h3 className="text-2xl font-bold text-center mb-6 pt-12 pb-5 sm:text-xl md:text-4xl">
        Transform Your Space with Grow Home Studio
      </h3>
      <p className="text-lg text-gray-700 text-center mb-4 sm:text-l sm:px-4">
        At Grow Home Studio, Hyderabad. we blend aesthetics with practicality to create
        interiors that truly resonate with your style and needs.
      </p>
      <p className="text-lg text-gray-700 text-center mb-4 sm:text-l sm:px-4">
        Using cutting-edge techniques and materials, we craft timeless
        designs that enhance the beauty and functionality of your home.
      </p>
      <p className="text-lg text-gray-700 text-center mb-4 sm:text-l sm:px-4">
        we can proudly say that we are the best interior designers in Hyderabad</p>
      <div className="text-center mt-6 pb-12">
        <button
          className="bg-[#e9a200] hover:bg-[#d78f00] text-white font-regular py-2 px-6 rounded-xl mx-auto"
          onClick={openQuotation} // Use openQuotation here
        >
          Get a Quotation
        </button>
      </div>
    </div>
  );
};

export default QuotationComponent;
